import React, { memo, FC } from "react";
import { useSelector } from "react-redux";
import { Tooltip } from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";
import { FaFilePdf } from "react-icons/fa";

interface GetAuctionCataloguePDFProps {
	handleRetrieveAuctionCataloguePDF: () => void;
	isLoading: boolean;
}

// Downloads the catalogue PDF made on the server (same as the client portal's Download PDF), like the CSV button.
const GetAuctionCataloguePDF: FC<GetAuctionCataloguePDFProps> = ({
	handleRetrieveAuctionCataloguePDF,
	isLoading,
}) => {
	const { settings } = useSelector((state: any) => state.settings);

	return (
		<Tooltip
			title={"Download the " + settings.AuctionName + " Catalogue in PDF"}>
			<LoadingButton
				onClick={handleRetrieveAuctionCataloguePDF}
				variant="text"
				className="btn-outline-primary d-flex align-items-center justify-content-center d-40 mr-2 p-0 rounded-pill text-capitalize"
				loading={isLoading}>
				<FaFilePdf />
			</LoadingButton>
		</Tooltip>
	);
};

export default memo(GetAuctionCataloguePDF);
